export interface ReportSubcategory {
  readonly label: string;
  readonly mandatoryDocument: boolean;
  readonly name: string;
}

export interface ReportCategory {
  readonly label: string;
  readonly name: string;
  readonly subCategories: ReportSubcategory[];
}

export class ReportMapper {
  static mapApiCategoriesToReportCategories(apiCategories): ReportCategory[] {
    return apiCategories.map((category) => this.mapCategory(category));
  }

  private static mapCategory(apiCategory): ReportCategory {
    return {
      label: apiCategory.humanized_name,
      name: apiCategory.name,
      subCategories: apiCategory.subcategories.map((sub) => this.mapSubcategory(sub)),
    };
  }

  private static mapSubcategory(apiSubcategory): ReportSubcategory {
    return {
      label: apiSubcategory.humanized_name,
      name: apiSubcategory.name,
      mandatoryDocument: apiSubcategory.mandatory_document,
    };
  }
}
